import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter, Link } from "react-router-dom";
import { NavDropdown, MenuItem, Image } from "react-bootstrap";
import API from "../../services/APIService";
import { mapStateToProps } from "../../RootReducer";
import { logout } from "../../actions/UserActions";
import Materialicon from "../helpers/Materialicon";

class UserDropdown extends React.Component {
	logout = () => {
		this.props.dispatch(logout(null));
		this.props.history.push("/login");
	}
	
	staticUrl = API.getStaticUrl();

	render() {
		const { first_name: firstName, last_name: lastName, image } = this.props.globalState.userLoginData.user;
		return (
			<div className="user-dropdown">
				<Image src={`${this.staticUrl}/uploads/${image || "defaultUserImage.png"}`} alt="user-avatar" />								

				<NavDropdown eventKey="3" title={`${firstName} ${lastName}`} id="user-dropdown-text">
					<li><Link to="/dashboard"><Materialicon icon="dashboard"/>Dashboard</Link></li>
					<li><Link to="/profile"><Materialicon icon="person"/> Profile</Link></li>
					<MenuItem divider />
					<MenuItem onClick={this.logout}><Materialicon icon="exit_to_app"/>Log Out</MenuItem>
				</NavDropdown>
			</div>
		);
	}
}

UserDropdown.propTypes = {
	globalState: PropTypes.shape({
		userLoginData: PropTypes.shape({
			user: PropTypes.shape({
				first_name: PropTypes.string,
				last_name: PropTypes.string,
				image: PropTypes.string,
			}).isRequired
		}).isRequired
	}).isRequired,
	dispatch: PropTypes.func.isRequired,
	history: PropTypes.shape({
		push: PropTypes.func.isRequired
	}).isRequired
};

export default connect(mapStateToProps)(withRouter(UserDropdown));


// WEBPACK FOOTER //
// ./src/components/navigation/UserDropdown.js